import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';

export default function RequireActivePlan({ children }) {
  const { loading, needsSubscription } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  const onPlansSettings =
    location.pathname === '/settings' || location.pathname.startsWith('/settings');

  if (needsSubscription && !onPlansSettings) {
    return <Navigate to="/settings#plans" replace />;
  }

  return children;
}
